<template>
  <div class="contacts-group__city header-city" v-if="active_region">
    <i class="fa fa-location-dot header-city__icon"></i>
    <span
      class="header-city__city-btn"
      @click="getModalRegions()">{{ active_region.title }}</span>

    <div class="header-city__modal-select modal-regions" v-if="regionsModalVisible">

      <button
        @click="closeRegionsModal"
        type="button" class="close modal-header__close-btn" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>

      <div class="container">
        <div class="modal-regions__title">Выбрать регион</div>
        <div class="modal-regions__search-city search-city">
          <input
            v-model="query"
            @input="$event.target.composing = false"
            type="text" class="form-control modal-regions__search-input">

          <ul class="search-city__results search-city-results" v-if="search_results">
            <li
              v-for="item in search_results"
              :key="'region-search_' + item.id"
              class="search-city-results__item">
                <a
                  @click="setRegion(item.get_absolute_url)"
                  href="javascript:;"
                  class="search-city-results__link">{{ item.title }}</a>
            </li>
          </ul>
        </div>
        <div class="modal-regions__content">
          <div class="modal-regions__promotes">
            <ul class="modal-regions__promote-cities promote-cities" v-if="promote_cities">
              <li 
                v-for="item in promote_cities"
                :key="'promote_' + item.id"
                class="promote-cities__item">
                  <a
                    @click="setRegion(item.get_absolute_url)"
                    href="javascript:;"
                    class="promote-cities__link">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="modal-regions__full-list">
            <div class="city-list__label">Все города:</div>
            <div class="modal-regions__list city-list">
              <ul class="modal-regions__cities cities" v-if="regions">
                <li 
                  v-for="item in regions"
                  :key="'city_' + item.id"
                  class="cities__item">
                    <a
                      @click="setRegion(item.get_absolute_url)"
                      href="javascript:;"
                      class="cities__link">{{ item.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import UtilsMixin from '../vue_mixins/UtilsMixin.vue'


export default {

  name: 'RegionSelect',
  mixins: [UtilsMixin],

  data () {
    return {
      active_region: null,
      region_confirm_block: true,
      city_confirm_cookie: false,
      errors: null,
      regions: null,
      promote_cities: null,
      query: '',
      search_results: null,
      regionsModalVisible: false
    }
  },

  watch: {
    query (newValue, oldValue) {

      if (newValue.length > 1 && newValue != oldValue) {
        this.searchAutocomplete()
      }
      else if(newValue.length < 1) {
        this.search_results = null
      }
    }
  },
  mounted () {
    axios.get(`/regions/api/active/?session=${this.uuid()}`).then(
      response => {
        this.active_region = response.data
      }
    )

    this.city_confirm_cookie = this.getCookie("sockontrakt_rus_hide_city_confirm")

    if(!this.city_confirm_cookie) {
      this.region_confirm_block = true
    }
    else{
      this.region_confirm_block = false
    }
  },

  methods: {
    setRegion (url) {
      this.city_confirm_cookie = 1
      this.setCookie('sockontrakt_rus_hide_city_confirm', '1', 1);
      window.location.href = url
    },

    hideRegionConfirmBlock (){
      this.region_confirm_block = false
      this.city_confirm_cookie = 1
      this.setCookie('sockontrakt_rus_hide_city_confirm', '1', 1)
    },
    getModalRegions () {

      this.regionsModalVisible = true

      axios.get("/regions/api/list/?promote=true").then(
        response => {
          this.promote_cities = response.data
        }
      )

      axios.get("/regions/api/list/").then(
        response => {
          this.regions = response.data
        }
      )
      this.region_confirm_block = false
    },

    closeRegionsModal () {
      this.regionsModalVisible = false
      this.regions = null
      this.promote_cities = null
    },

    searchAutocomplete () {
      if(this.query.length > 1){
        axios.get("/regions/api/list/?query="+this.query).then(
          response => {
            this.search_results = response.data
          }
        )
      }
      else {
        this.search_results = []
      }
    },

    setCookie(cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + (exdays*24*60*60*1000))
      var expires = "expires="+ d.toUTCString()
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
    },

    getCookie (cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')

      for(var i = 0; i <ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }

      return false
    }
  }
}
</script>

<style lang="css" scoped>
</style>